<template>
  <div class="login-card__success-card">
    <div>
      <div class="login-card__big-icon login-card__big-icon--congrats">
        <picture>
          <source media="(max-width: 1199.98px)" srcset="../../../images/registration/congrats-mobile.png">
          <img src="../../../images/registration/congrats.png" alt="Congratulation icon">
        </picture>
      </div>

      <div class="login-card__title-box">
        <h2 class="login-card__title">{{ trans.get('auth.card.success.header') }}</h2>
        <p class="login-card__title-desc">{{ trans.get('auth.card.success.message') }}</p>
      </div>

      <button type="button" @click="redirect" class="button__auth">
        {{ trans.get('auth.card.buttons.finished') }}
      </button>

      <p class="login-card__steps">
        <span class="steps__step">01</span>
        <span class="steps__step">02</span>
        <span class="steps__step">03</span>
        <span class="steps__step">04</span>
        <span class="steps__step steps__step--active">05</span>
      </p>

      <Step :step="5"></Step>
    </div>
  </div>
</template>
<script>
import Step from './Step';

export default {
  components: { Step },
  props: {
    swapComponent: Function,
    timeout: {
      default: 5000,
    }
  },
  methods: {
    redirect() {
      window.location.href = zRoute('front.members.index');
    }
  },
  mounted() {
    if (this.timeout > 0) {
      setTimeout(() => {
        this.redirect();
      }, this.timeout);
    }
  },
};
</script>
<style scoped>
</style>
